import { DIRECTIONS } from './sort-direction';

// The inclusive timestamp bound is implied by the _or, but Postgres can't turn an _or into an index
// range; without the bound, a deep page scans every row before the cursor, as OFFSET would.
export function buildCursorTerm(cursor, direction) {
  if (!cursor) return null;
  const { comparator, inclusiveComparator } = DIRECTIONS[direction];
  return {
    timestamp: { [inclusiveComparator]: cursor.timestamp },
    _or: [
      { timestamp: { [comparator]: cursor.timestamp } },
      { timestamp: { _eq: cursor.timestamp }, id: { [comparator]: cursor.id } },
    ],
  };
}
